import React, { useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { FilterAlt } from "@mui/icons-material";
import { CustomIconButton } from "../../../shared/CustomIconButton";
import axios from "axios";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const AvailableWallet = () => {
  const [data, setData] = useState([]);
  const superuserId = localStorage.getItem("is_superuser");

  const availableDataList = () => {
  
      superuserId === "true"
        ? axios
            .post(
              `https://app1.crazzyhub.com/api/multivendor-available-vendor-wallets-list/`,
              {},
              {
                headers: {
                  Token: localStorage.getItem("Token"),
                },
              }
            )
            .then((response) => {
              setData(response?.data?.active_vender_wallet);
            })
            .catch((error) => {
              console.log("", error);
            })
        : axios
            .post(
              `https://app1.crazzyhub.com/api/multivendor-available-vendor-wallets-admin/`,
              {},
              {
                headers: {
                Token:"d3c1e6d0a7c3645507d87e10ecdd970933408c5f"
                },
              }
            )
            .then((response) => {
              setData(response?.data?.active_vender_wallet);
            })
            .catch((error) => {
              console.log("", error);
            });
    
  };

  useEffect(() => {
    availableDataList();
  }, []);

  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">
            Manage Available Vendor List
          </p>
          <p className="!text-black">View/Search Available Vendor List</p>
        </div>
        <div className="p-2 pt-5">{/* <CreateResellers /> */}</div>
      </div>
      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex items-center justify-between my-2">
          <span className="flex  gap-3">
            <CustomIconButton>
              <FilterAlt className="!text-black" />
            </CustomIconButton>
            <input
              type="text"
              //   value={searchQuery}
              className="!border-3 !border-black !w-72 px-2 rounded-md py-1"
              placeholder="search"
              style={{ border: "1px solid black" }}
              //   onChange={(event) => setSearchQuery(event.target.value)}
            />
          </span>
          <span>
            <div className="text-red-500 mx-3">
              {/* <Button variant="outlined" color="primary" onClick={handleOpen}> */}
              {/* <AddIcon />
                Add Inventry
              </Button>
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
              >
                <Box
                  sx={{ ...style, width: 430 }}
                  className="rounded-2xl !border-0"
                >
                  <div
                    id="child-modal-title "
                    className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
                  >
                    Add Inventry
                  </div>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Select Main Category</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Select Main Category"
                      size="small"
                      name="main_category_id"
                      onChange={(event)=>setMainCategoryId(event.target.value)}
                    >
                        {
                            mainCategoryData?.map((elem)=>
                            <MenuItem value={elem?.id}>{elem?.category}</MenuItem>
                            )
                        }
                    </Select>
                  </FormControl>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Select Main Sub Category</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Select Main Category"
                      size="small"
                      className="mt-3"
                      name="sub_category_id"
                      onChange={(event)=>setSubCategoryId(event.target.value)}
                    >
                      {
                            subCategoryData?.map((elem)=>
                            <MenuItem value={elem?.id}>{elem?.subcategory}</MenuItem>
                            )
                        }
                    </Select>
                  </FormControl>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Select Brand Name</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Select Main Category"
                      size="small"
                      className="mt-3"
                      name="brand_name_id"
                      onChange={(event)=>setBrandId(event.target.value)}
                    >
                      {
                            brandData?.map((elem)=>
                            <MenuItem value={elem?.id}>{elem?.brand_name}</MenuItem>
                            )
                        }
                    </Select>
                  </FormControl>
                  <TextField
                    size="small"
                    id="outlined-basic"
                    label="Product Name"
                    variant="outlined"
                    className="!w-[100%] !mt-3"
                    name="product_name"
                    onChange={(event)=>setProductName(event.target.value)}
                  />

                  <br />
                  <br />
                  <Button
                    onClick={hangleCancel}
                    variant="contained"
                    color="warning"
                    className="!py-2 !mt-3"
                  >
                    CANCEL
                  </Button>
                  <Button
                    variant="contained"
                    type="submit"
                    color="success"
                    className="!py-2 !px-5 !font-bold !mt-3 !float-right"
                    onClick={submitCategory}
                  >
                    ADD
                  </Button>
                </Box>
              </Modal> */}
            </div>
          </span>
        </div>
        <TableContainer
          component={Paper}
          // sx={{  }}
          sx={{ width: "100%", maxHeight: 440 }}
          className="!text-black !mx-auto !bg-white overflow-auto px-2"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ID
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  USER NAME
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  IMAGE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  MOBILE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  EMAIL
                </TableCell>

                <TableCell
                  style={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  BALANCE
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="!bg-red">
              {data &&
                data?.map((row, index) => (
                  <TableRow key={row.id} className="!text-slate-700">
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row.id ? row.id : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.user?.first_name ? row?.user?.first_name : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.user?.profile_picture ? (
                        <img
                          src={row?.user?.profile_picture}
                          alt="No"
                          className="h-8 mx-auto w-8"
                        />
                      ) : (
                        "--"
                      )}
                    </TableCell>

                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.mobile_number ? row?.mobile_number : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.user?.email ? row?.user?.email : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.balance ? row?.balance : "--"}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div
          className="!float-right relative bg-white w-[100%] mx-auto bottom-0 right-0 py-3 border-t-2 border-gray-400 !flex-col !justify-end !items-center"
          style={{ marginRight: "0px" }}
        >
          <button className="!float-right">
            <ArrowForwardIosIcon />
          </button>
          <button className="float-right">
            <ArrowBackIosIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AvailableWallet;
